<a
  *ngIf="rowItem.customFields.artist; else noartist"
  style="text-decoration: none;"
  [routerLink]="[
    '../../extensions/artists',
    rowItem.customFields.artist.id
  ]"
  ><span> {{ rowItem.customFields.artist.name }}</span></a
>
<ng-template #noartist>
  <div>*</div>
</ng-template>
